import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { fromJS, List } from 'immutable';
import { CustomValidators } from 'ngx-custom-validators';
import {
  Discount,
  DiscountTypesEnum,
} from '../../../document-data/sub-models/discount.model';
import { IValueSwitch } from '../../../form-master/components/value-switch-field/value-switch-field.component';
import { IFormMasterBuilder } from '../../../form-master/form-master.interface';
import {
  ICurrencyInfo,
  MoneyService,
} from '../../../shared/services/money/money.service';
import { I2gNgTrackingActionBuilder } from 'i2g-ng-tracking';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';

@Injectable()
export class DocumentDiscountBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    DISCOUNT_PERCENTAGE: 'discountPercentage',
    DISCOUNT_AMOUNT: 'discountAmount',
    DISCOUNT_TYPE: 'discountType',
  };

  constructor(
    private _formBuilder: FormBuilder,
    private _moneyService: MoneyService,
    private _trackingActionBuilder: I2gNgTrackingActionBuilder
  ) {}

  buildForm(discount: Discount): FormGroup {
    return this._formBuilder.group({
      [this.FORM_KEYS.DISCOUNT_TYPE]: [
        discount.type === DiscountTypesEnum.no_discount
          ? DiscountTypesEnum.percentage
          : discount.type,
      ],
      [this.FORM_KEYS.DISCOUNT_AMOUNT]: [
        discount.amount,
        CustomValidators.range([0, 9999999999999]),
      ],
      [this.FORM_KEYS.DISCOUNT_PERCENTAGE]: [
        discount.percentage,
        CustomValidators.range([0, 100]),
      ],
    });
  }

  buildDiscountSwitches(
    currencyCode: string,
    trackingObject: ITrackingObject,
    trackingScreenName: TrackingScreenNamesEnum
  ): List<IValueSwitch> {
    const currencyInfo: ICurrencyInfo =
      this._moneyService.getCurrencyInfo(currencyCode) ||
      this._moneyService.getCurrencyInfo();

    return List([
      {
        key: '%',
        value: DiscountTypesEnum.percentage,
        trackingObject: trackingObject,
        trackingAction: this._trackingActionBuilder.buildButtonTapped(
          'to_percentage',
          trackingScreenName
        ),
      },
      {
        key: currencyInfo.symbol,
        value: DiscountTypesEnum.amount,
        trackingObject: trackingObject,
        trackingAction: this._trackingActionBuilder.buildButtonTapped(
          'to_currency_amount',
          trackingScreenName
        ),
      },
    ]);
  }

  buildDiscountProps(discountInfo: Map<string, any>): Map<string, any> {
    const formKeys = this.FORM_KEYS;
    const discountProps = {
      [Discount.KEYS.TYPE]: discountInfo.get(formKeys.DISCOUNT_TYPE),
      [Discount.KEYS.AMOUNT]: discountInfo.get(formKeys.DISCOUNT_AMOUNT) || 0,
      [Discount.KEYS.PERCENTAGE]:
        discountInfo.get(formKeys.DISCOUNT_PERCENTAGE) || 0,
    };

    return fromJS(discountProps);
  }
}
